import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const CaravanSVG: React.FunctionComponent<StyledProps> = ({
  width = 20,
  height = 15,
  display = "inline-flex",
  marginX = 0,
  ...props
}) => {
  return (
    <StyledContainer {...props}>
      <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
        <path
          d="M21.45 11.8333H19.8V6.16667C19.8 4.66377 19.2205 3.22243 18.1891 2.15973C17.1576 1.09702 15.7587 0.5 14.3 0.5L2.2 0.5C1.61652 0.5 1.05695 0.738809 0.644365 1.16389C0.231785 1.58897 0 2.16551 0 2.76667L0 11.8333C0 12.4345 0.231785 13.011 0.644365 13.4361C1.05695 13.8612 1.61652 14.1 2.2 14.1H3.3C3.3 15.0017 3.64768 15.8665 4.26655 16.5042C4.88542 17.1418 5.72479 17.5 6.6 17.5C7.47521 17.5 8.31458 17.1418 8.93345 16.5042C9.55232 15.8665 9.9 15.0017 9.9 14.1H21.45C21.5959 14.1 21.7358 14.0403 21.8389 13.934C21.9421 13.8278 22 13.6836 22 13.5333V12.4C22 12.2497 21.9421 12.1056 21.8389 11.9993C21.7358 11.893 21.5959 11.8333 21.45 11.8333ZM6.6 15.8C6.27366 15.8 5.95465 15.7003 5.68331 15.5135C5.41197 15.3267 5.20048 15.0612 5.0756 14.7506C4.95071 14.4399 4.91804 14.0981 4.9817 13.7683C5.04537 13.4386 5.20252 13.1357 5.43327 12.8979C5.66403 12.6602 5.95803 12.4983 6.2781 12.4327C6.59817 12.3671 6.92993 12.4007 7.23143 12.5294C7.53293 12.6581 7.79062 12.876 7.97192 13.1555C8.15323 13.4351 8.25 13.7638 8.25 14.1C8.24955 14.5507 8.07556 14.9829 7.76622 15.3016C7.45689 15.6203 7.03747 15.7995 6.6 15.8ZM8.8 7.3C8.8 7.60058 8.68411 7.88885 8.47782 8.10139C8.27153 8.31393 7.99174 8.43333 7.7 8.43333H3.3C3.00826 8.43333 2.72847 8.31393 2.52218 8.10139C2.31589 7.88885 2.2 7.60058 2.2 7.3V5.03333C2.2 4.73275 2.31589 4.44449 2.52218 4.23195C2.72847 4.0194 3.00826 3.9 3.3 3.9H7.7C7.99174 3.9 8.27153 4.0194 8.47782 4.23195C8.68411 4.44449 8.8 4.73275 8.8 5.03333V7.3ZM15.4 7.3C15.4 7.60058 15.2841 7.88885 15.0778 8.10139C14.8715 8.31393 14.5917 8.43333 14.3 8.43333H12.1C11.8083 8.43333 11.5285 8.31393 11.3222 8.10139C11.1159 7.88885 11 7.60058 11 7.3V5.03333C11 4.73275 11.1159 4.44449 11.3222 4.23195C11.5285 4.0194 11.8083 3.9 12.1 3.9H14.3C14.5917 3.9 14.8715 4.0194 15.0778 4.23195C15.2841 4.44449 15.4 4.73275 15.4 5.03333V7.3Z"
          fill="black"
        />
      </svg>
    </StyledContainer>
  );
};

export default CaravanSVG;
